/**
 *微聊投诉
*/
import request from '@/utils/request';
// import { getToken } from '@/utils/auth';
// import ENVIRONMENT from '@/utils/environment';

// 分页查询社区列表
export function get_complain_pagelist(options) {
  return request({
    url: `/op/complain/queryPageList`,
    method: 'get',
    params: options
  });
}
// 根据投诉Id获取详情
export function get_complain_detail(id) {
  return request({
    url: `/op/complain/get/${id}`,
    method: 'get'
  });
}
// 根据投诉Id驳回投诉
export function rejectedComplaint(id) {
  return request({
    url: `/op/complain/rejectedComplaint`,
    method: 'post',
    data: { id }
  });
}
// 投诉冻结
export function freezeComplaint(id) {
  return request({
    url: `/op/complain/freezeComplaint`,
    method: 'post',
    data: { id }
  });
}
// 投诉永久冻结
export function foreverFreezeComplaint(id) {
  return request({
    url: `/op/complain/foreverFreezeComplaint`,
    method: 'post',
    data: { id }
  });
}
// 投诉解冻
export function unfreeze(id) {
  return request({
    url: `/op/complain/unfreeze`,
    method: 'post',
    data: { id }
  });
}

// 投诉类型分页列表
export function get_complain_queryTypePageList(data) {
  return request({
    url: `/op/complain/queryTypePageList`,
    method: 'get',
    params: data
  });
}
// 投诉类型详情列表
export function getSubTypes(id) {
  return request({
    url: `/op/complain/getSubTypes/${id}`,
    method: 'get'
  });
}
// 投诉类型停用启用
export function type_complain_delete(id, data) {
  return request({
    url: `/op/complain/disable/${id}`,
    method: 'PUT',
    data
  });
}
// 投诉类型添加
export function type_complain_add(data) {
  return request({
    url: `/op/complain/add`,
    method: 'post',
    // headers: {
    //   'Content-Type': 'application/x-www-form-urlencoded'
    // },
    data
  });
}

// 投诉类型停用
export function type_complain_enable(id, data) {
  return request({
    url: `/op/complain/enable/${id}`,
    method: 'PUT',
    data
  });
}
// 投诉类型字典
export function getParentTypes() {
  return request({
    url: `/op/complain/getParentTypes`,
    method: 'get'
  });
}
// 删除投诉多个id用逗号拼接
export function deleteRow(id) {
  return request({
    url: `/op/complain/delete/${id}`,
    method: 'DELETE'
  });
}
// 通过投诉类型新增投诉名称
export function addComplaintName(data) {
  return request({
    url: `/op/complain/name`,
    method: 'POST',
    data
  });
}
// 编辑
export function updateComplaintName(id, data) {
  return request({
    url: `/op/complain/${id}`,
    method: 'PUT',
    data
  });
}
